export default __webpack_public_path__ + "static/media/x.b65b992c.svg";